var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',_vm._l((_vm.boletos),function(boleto,index){return _c('div',{key:index,staticClass:"elemento-nao-quebrar"},[_c('boleto',{attrs:{"dadosBoleto":boleto}}),_c('div',{staticClass:"linha-tracejada"})],1)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }